/**
 * @function addScript - добавляет скрипт на страницу
 * @param {string} content - контент скрипта
 * @param {boolean} remove - признак удаления скрипта после загрузки
 * */

export default function addScript(content, remove = false) {
    const script = document.createElement('script');
    script.innerHTML = content;
    document.head.append(script);

    if (remove) {
        script.remove();
    }
}
